// @flow
import type { State } from 'model/State';

export default (state: State) => state.marketplace.search.params;
